/**
 * 小程序用户
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>小程序用户</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" ref="formInline" class="user-search">
      <el-form-item label="搜索：" prop="name">
        <el-input size="small" v-model="formInline.name" placeholder="输入昵称"></el-input>
      </el-form-item>
      <el-form-item label=""  prop="fromWhere">
        <el-input size="small" v-model="formInline.fromWhere" placeholder="输入国家、省份、城市"></el-input>
      </el-form-item>
      <el-form-item prop="gender">
        <el-select size="small" v-model="formInline.gender" placeholder="性别">
          <el-option v-for="type in gender" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="date_time">
        <el-date-picker
          v-model="formInline.date_time"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="resetForm('formInline')">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="id" label="主键" v-if="false" width="200" show-overflow-tooltip>
      </el-table-column>
      
      <el-table-column sortable prop="avatarurl" label="头像" width="70" show-overflow-tooltip>

        <template slot-scope="scope">
            <el-popover placement="top-start" title="" trigger="hover">
              <img :src="scope.row.avatarurl" alt="" style="width: 150px;height: 150px">
              <img slot="reference" :src="scope.row.avatarurl" style="width: 40px;">
            </el-popover>
        </template>
        <!-- <template slot-scope="scope">
          <el-image style="width: 100%; height: 100px" :src="scope.row.avatarurl" :preview-src-list="[scope.row.avatarurl]" :key="scope.row.cid">
            <div slot="error" class="image-slot">
               <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template> -->

      </el-table-column>

      <el-table-column align="center" sortable prop="nickname" label="昵称" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-tag effect="light" size="medium">{{ scope.row.nickname }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="country" label="国家" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="province" label="省份/行政区" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="city" label="城市" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="language" label="语言" width="250" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="gender" label="性别" width="100" show-overflow-tooltip>
        <template slot-scope="{row}">
            <div style="color:green;" v-if="row.gender == 1">
                男
            </div>
            <div style="color:blue;" v-else-if="row.gender == 2">
                女
            </div>
            <div v-else>
                未知
            </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="ctime" label="创建时间" min-width="150" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import { WxUserList } from '../../api/basisMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      showImg: false,
      gender: [
        { key: '男', value: 1 },
        { key: '女', value: 2 },
        { key: '未知', value: 0 },
      ],
      formInline: {
        date_time:[],
        page: 1,
        limit: 10,
        name: '',
        gender: '',
        fromWhere: '',
        startTime: '',
        endTime: '',
        Token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据列表
    getdata(parameter) {
      this.loading = true
      WxUserList(parameter)
        .then(res => {
          // console.log(res)
          this.loading = false
          if (res.result != 'success') {
            this.$message({
              type: 'info',
              message: '请求失败'
            })
          } else {
            this.listData = res.list
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$message.error(err.response.statusText)
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      // this.$message({
      //   type: 'success',
      //   message: '这是一个小提示'
      // })
      //时间段为空，则开始和结束时间都为空
      if(this.formInline.date_time[0]) {

        this.formInline.startTime = this.formInline.date_time[0]
      }else{
        this.formInline.startTime = ''
      }
      if(this.formInline.date_time[1]) {
        this.formInline.endTime = this.formInline.date_time[1]
        
      }else{
        this.formInline.endTime = ''
      }
      this.getdata(this.formInline)
    },
    //重置
    resetForm(formName) {
        this.$refs[formName].resetFields();
    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/miniBase/MiniUser.vue